import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from "@/i18n";


export default {
  namespaced: true,
  state: {
    fetched: false,
    intervals: []
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async update({ commit, state, dispatch }, payload){
      updateField(state, {path:'fetched', value:false});
      return axios.put(this._vm.$apiURL + '/intervals/'+payload.id, payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'));
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
          return Promise.reject()
        }).finally(()=>{
          updateField(state, {path:'fetched', value:true});
        })
    },
    async get({ commit, state, dispatch }, payload){
      //if(!state.fetched) return;
      updateField(state, {path:'fetched', value:false});
      return await axios.get(`${this._vm.$apiURL}/intervals?date=${payload.date}`)
        .then((response) => {
          updateField(state, {path:'intervals', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'fetched', value:true});
        })
    },
  }
}
